import styled, { css } from 'styled-components';

const StyledLabel = styled.label`
  width: ${({ errorInLabel, width }) => {
    if (errorInLabel) {
      return 'auto;';
    }

    if (width) {
      return width;
    }

    return '100%';
  }};
  color: ${props => props.labelColor || props.theme.secondaryColor};
  font-size: 14px;
  font-weight: ${props => !props.unBoldLabel && '600'};
`;

export default StyledLabel;
